var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.352,
    height: 54.514,
    viewBox: "0 0 54.352 54.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(-5354.294 -39.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M5408.646,66.835a27.176,27.176,0,1,1-27.177-27.176A27.177,27.177,0,0,1,5408.646,66.835Z",
    fill: "#ebedf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M5387.119,77.617V75.963a14.556,14.556,0,0,0,4.184-7.047.79.79,0,0,0,.215.093c.955.163,1.985-1.6,2.3-3.938s-.2-4.364-1.16-4.526a1.017,1.017,0,0,0-.834.332c-.019-.14-.042-.277-.065-.415q.166-.781.328-1.563a9.615,9.615,0,0,0,.151-5,6.455,6.455,0,0,0-1.372-2.226,11.832,11.832,0,0,0-7.291-3.635,18.155,18.155,0,0,0-8.185,1.007c-1.565.539-3.361,1.738-3.04,3.361a1.713,1.713,0,0,0-2.019,1.136,4.99,4.99,0,0,0-.057,2.539q.352,2.323.705,4.647a.891.891,0,0,0-.649-.181c-.955.162-1.474,2.189-1.159,4.526s1.345,4.1,2.3,3.938a.784.784,0,0,0,.215-.093,14.549,14.549,0,0,0,4.184,7.047v1.619c-6.57.673-12.34,2.533-16.468,5.147a27.046,27.046,0,0,0,44.08.147C5399.41,80.23,5393.673,78.332,5387.119,77.617Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5d4de195f6d25b326d70c782754cb340.svg";
export { ForwardRef as ReactComponent };